export default {_name:'note.list',module:'Card/List',view:'Element/Note/List',options:{md:12}}